import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CentrosModel } from 'src/app/pages/configuracion/maestros/centros/models/centros-model';
import { IRecuperarCentrosService } from './ports/i-recuperar-centros-service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LoginService } from 'src/app/pages/login/services/login.service';
import { EndpointService } from 'src/app/shared/services/endpoint.service';
import { map } from 'rxjs/operators';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';
import { EmpresasModel } from '../../empresas/models/empresas-model';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { FiltroBasico } from 'src/app/shared/models/filtros';


@Injectable({
  providedIn: 'root'
})
export class RecuperaCentrosApiService implements IRecuperarCentrosService{

  private readonly URL_GET_CENTROS: string = this.endpointService.UrlGetCentros;
  private readonly URL_GUARDA_CENTRO: string = this.endpointService.UrlGuardaCentro;
  private readonly URL_GUARDA_CENTROS: string = this.endpointService.UrlGuardaCentros;
  private readonly URL_DELETE_CENTRO: string = this.endpointService.UrlDeleteCentro;
  centros: CentrosModel[];
  countCentros: number = 0;
  empresas: EmpresasModel[];

  constructor(private client: HttpClient,
              private loginService: LoginService,
              private endpointService: EndpointService,
              private conversionDatosApiService: ConversionDatosApiService) { }

  getCentros(filtros: FiltroBasico[], pageNumber:number, orden: OrdenColumna = {campoOrden:'', orden:''}): Observable<CentrosModel[]> {

    let pageSizeParam:number = pageNumber==0 ? 0 : 50;
    let pageNumberParam:number = pageNumber==0 ? 0 : pageNumber;
    let filtroBuscar = filtros.find(x=>x.text=='Buscar')?.value;

      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.loginService.getUserLocalStorage().Token.Token
        }),
        params: new HttpParams()
        .set('pageNumber', pageNumberParam)
        .set('pageSize', pageSizeParam)
        .set('filtroBuscar', filtroBuscar ? filtroBuscar : '')
      };

      if (orden.campoOrden) {
        options.params = options.params.set(`orden[${orden.campoOrden.toUpperCase()}]`, orden.orden);
      }

      return this.client.get(this.URL_GET_CENTROS, options).pipe(
        map((response: any) =>{
          if (response) {
            this.centros = this.conversionDatosApiService.mapCentrosEntrada(response);
            return this.centros;
          }
          else throw new Error(response);
        })
      );
  }

  guardaCentro(data:any): Observable<void>{
    data = this.conversionDatosApiService.mapCentrosSalida(data);
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.post<void>(this.URL_GUARDA_CENTRO, data, options)
  }

  guardaCentros(data:CentrosModel[]): Observable<void>{

    let dataEnvio:any[] = [];
    if(data==null || data.length==0 ) return of();
    data.forEach(x=> dataEnvio.push(this.conversionDatosApiService.mapCentrosSalida(x)));
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.post<void>(this.URL_GUARDA_CENTROS, dataEnvio, options)
  }

  deleteCentro(data: CentrosModel): Observable<void> {
    let url = this.URL_DELETE_CENTRO.replace("{codigoCentro}", data.codigoCentro).replace("{codigoEmpresa}", data.codigoEmpresa);

    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token
      })
    };
    return this.client.delete<void>(url, options)
  }

}
